import { IAjaxBaseState, ajaxBaseState } from 'flux-entities'

import { IUser } from '../../types/user'

export interface IUsersState extends IAjaxBaseState<IUser> {
}

const createInitialUsersState = (): IUsersState => {
  return {
    ...ajaxBaseState()
  }
}

export {
  createInitialUsersState
}
